import { AnyGameState, TournamentGameState } from "../store/game/store";

export default function isTournamentState(
  state: AnyGameState,
): state is TournamentGameState {
  return "tournament" in state;
}
